import { defineComponent as _defineComponent } from 'vue'
import { computed, PropType, ref, watch } from 'vue'
import { authModule } from '@/store'
import { obrigatorio } from '@/shareds/regras'
import { intersectRoles } from '@/helpers/auth-helpers'
import { InputIrmao } from 'common/types/Irmao'
import SeletorDePotencia from '@/components/SeletorDePotencia.vue'
import SeletorDeGrauDoMacon from '@/components/SeletorDeGrauDoMacon.vue'
import SeletorDeCidade from '@/components/seletores/SeletorDeCidade.vue'


const __default__ = {
	model: {
		prop: 'irmao',
	},
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'FormPerfil',
  props: {
	irmao: { type: Object as PropType<InputIrmao>, required: true },
	novaFoto: { type: null as unknown as PropType<File | null> },
},
  emits: ["update:novaFoto"],
  setup(__props, { emit }: { emit: ({
	(e: 'update:novaFoto', foto: File | null): void
}), expose: any, slots: any, attrs: any }) {

const props = __props;





const syncNovaFoto = computed({
	get: () => props.novaFoto,
	set: (foto: File | null | undefined) => emit('update:novaFoto', foto ?? null),
})

const fotoPreview = ref('')

const fotoInput = ref<HTMLInputElement>()

function onFotoChange() {
	const input = fotoInput.value!
	if (!input.files) return
	const [file] = input.files
	syncNovaFoto.value = file
}

watch(() => props.novaFoto, (novaFoto) => {
	if (!novaFoto) {
		fotoPreview.value = ''
		return
	}
	const reader = new FileReader()

	reader.addEventListener('load', () => {
		fotoPreview.value = reader.result as string
	}, false)

	reader.readAsDataURL(novaFoto)
}, { immediate: true })

function fotoIrmao(irmao: InputIrmao) {
	return fotoPreview.value || irmao.foto
}

function removerFoto(irmao: InputIrmao) {
	irmao.foto = ''
	syncNovaFoto.value = null
}

return { __sfc: true,props, emit, syncNovaFoto, fotoPreview, fotoInput, onFotoChange, fotoIrmao, removerFoto, authModule, obrigatorio, intersectRoles, SeletorDePotencia, SeletorDeGrauDoMacon, SeletorDeCidade }
}

})